import React, { useEffect } from 'react'
import { employeeFromDatabase } from '../Utils/dummy_data'

const PersonCard = ({ person, handleError }) => {
    return (<div className={`text-center  max-w-[165px] capitalize  ${person?.description ? " col-span-full mx-auto" : ""} `}>
        <div className='w-44 h-44  rounded-full object-cover mx-auto mt-2 border overflow-hidden'>
            <img src={`/Assets/Emp_images/${person?.emp_id}.jpg`} onError={handleError}
                alt={`${person?.name}`} id={`${person?.emp_id}_${person?.name}`} key={`${person?.emp_id}_${person?.name}`} />
        </div>
        <p className='font-semibold  mx-auto  '
    /* onClick={() => handleEmployeeClick(person)} */>{person?.name}</p>
        <p className='font-thin text-sm'>{person.designation}</p>
        <p className='py-4 md:w-1/2 lg:w-1/3 px-8   text-lg text-center mx-auto'> {person?.description}</p>

    </div>)
}


const FilledStrip = ({ text }) => {

    return (
        <div className='px-16 text-center w-full border-t-2 border-b-2 border-second border-opacity-20 py-2 text-lg 
        font-[700] tracking-wide bg-second bg-opacity-10' >
            <h2>{text}</h2>
        </div>)
}

const scrollToELement =(element)=>{
    document.getElementById(element)?.scrollIntoView({ behavior: 'smooth' });
}


const PeopleMainContent = ({ department, onImageError }) => {


    useEffect(() => {
        scrollToELement(`div_${department.split(" ").join("")}`)    
    }, [department])




    return (<div className=' overflow-y-scroll w-full cool-hover'>{Object.entries(employeeFromDatabase).map(emplist => {


        return (<div id={`div_${emplist[0].split(" ").join("")}`}
            className={`flex justify-center items-start   py-4 flex-wrap gap-8 md:gap-12 mt-4 md:px-[5%]  w-full`}>
            <FilledStrip text={emplist[0]} />

            {emplist[1]?.map(inner_item => <PersonCard handleError={onImageError} person={inner_item} />)}

        </div>)
    })}

    </div>)

}
export default PeopleMainContent